import { BlocksUtilityNavItem } from 'blocks-nextjs/blocks-web-components/components/utility-nav-item/utility-nav-item';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';
import { EventName } from '@lit/react';
import { BlocksCloseEvent, BlocksOpenEvent } from 'blocks-nextjs/blocks-web-components/events';

/**
 * @deprecated - This component `CatUtilityNavItem` has been deprecated and the updated version will be available with name `CatUtilityNavItemLabs`. New component will be found under labs folder from Minor Release 3.10.0, `CatUtilityNavItem` will be removed in 5.0 major release.
 */

export const CatUtilityNavItem = createComponent({
  react: React,
  tagName: 'cat-utility-nav-item',
  elementClass: BlocksUtilityNavItem,
  events: {
    onBlUtilityNavPanelClose: 'bl-utility-nav-panel-close' as EventName<BlocksCloseEvent>,
    onBlUtilityNavPanelOpen: 'bl-utility-nav-panel-open' as EventName<BlocksOpenEvent>
  }
});
